export const cssAppliedContent = (body) => `
  <div>
    <style jsx>
      .custom-table-wrapper {
          width: 100%;
          overflow-x: auto;
      }

      table {
        font-family: Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100% !important;
        min-width: 600px;
      }

      table td,
      table th {
        border: 1px solid #ddd;
        padding: 4px;
      }

      table tr:nth-child(even) {
        background-color: #f2f2f2;
      }

      table tr:hover {
        background-color: #ddd;
      }

      table th {
        padding-top: 8px;
        padding-bottom: 8px;
        text-align: left;
        background-color: #04aa6d;
        color: white;
      }
  </style>
    <div class="custom-table-wrapper">
      ${body}
    </div>
  <div>
  `;
